export const enhancer = (element) => {
  // Get random option
  const options = ["a", "b", "c", "d"];
  const random = options[Math.floor(Math.random() * options.length)];

  element.setAttribute("data-shape", random);
};
